export default function TokenSkeleton() {
  return (
    <div className="flex w-full flex-col items-start justify-between space-y-5 rounded-lg bg-white p-5">
      {/* Header skeleton */}
      <div className="flex w-full flex-row justify-between">
        <div className="w-full space-y-2">
          <div className="h-5 w-32 animate-pulse rounded bg-gray-300" />
          <div className="h-3 w-48 animate-pulse rounded bg-gray-300" />
        </div>
        <div className="flex flex-row gap-2">
          <div className="h-8 w-32 animate-pulse rounded bg-gray-300" />
          <div className="h-8 w-24 animate-pulse rounded bg-gray-300" />
        </div>
      </div>

      {/* Table skeleton */}
      <div className="flex w-full flex-col gap-2">
        <div className="scrollbar-thin overflow-x-auto">
          <table className="w-full table-fixed border-collapse text-sm">
            <thead>
              <tr className="text-left text-xs font-medium tracking-wide text-neutral-500 uppercase">
                <th className="w-[40%] px-4 py-3">
                  <div className="h-3 w-16 animate-pulse rounded bg-gray-300" />
                </th>
                <th className="w-[15%] px-4 py-3">
                  <div className="h-3 w-12 animate-pulse rounded bg-gray-300" />
                </th>
                <th className="w-[15%] px-4 py-3">
                  <div className="h-3 w-8 animate-pulse rounded bg-gray-300" />
                </th>
                <th className="w-[25%] px-4 py-3">
                  <div className="h-3 w-12 animate-pulse rounded bg-gray-300" />
                </th>
                <th className="w-[15%] px-4 py-3">
                  <div className="h-3 w-16 animate-pulse rounded bg-gray-300" />
                </th>
              </tr>
            </thead>
            <tbody>
              {[...Array(3)].map((_, i) => (
                <tr
                  key={i}
                  className="transition-colors hover:bg-neutral-100/80"
                >
                  <td className="px-4 py-4">
                    <div className="flex min-w-0 items-center gap-2">
                      <div className="h-7 w-9 animate-pulse rounded bg-gray-300" />
                      <div className="h-4 w-32 animate-pulse rounded bg-gray-300" />
                    </div>
                  </td>
                  <td className="px-4 py-4">
                    <div className="h-4 w-16 animate-pulse rounded bg-gray-300" />
                  </td>
                  <td className="px-4 py-4">
                    <div className="h-4 w-12 animate-pulse rounded bg-gray-300" />
                  </td>
                  <td className="px-4 py-4">
                    <div className="space-y-1">
                      <div className="h-3 w-20 animate-pulse rounded bg-gray-300" />
                      <div className="h-1 w-32 animate-pulse rounded bg-gray-300" />
                    </div>
                  </td>
                  <td className="px-4 py-4">
                    <div className="h-8 w-16 animate-pulse rounded bg-gray-300" />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
